import { useMutation } from '@vue/apollo-composable';
import { reactive, ref } from 'vue';
import dayjs from '@/dayjs';
import type { Customer as CustomerType } from '@/types';
import { ISSUE_INVOICE, SEND_DOCUMENT } from '../graphql';

interface InvoiceData {
  orderId: string;
  customer: CustomerType | null;
  dueInDays: number;
}

interface EmailInvoiceData {
  email: string;
  subject: string;
  content: string;
}

export function useSubmit() {
  const sendInvoice = ref(false);

  const invoiceData = reactive<InvoiceData>({
    orderId: '',
    customer: null,
    dueInDays: 14,
  });

  const emailInvoiceData = reactive<EmailInvoiceData>({
    email: '',
    subject: '',
    content: '',
  });

  const { mutate: issueInvoiceMutation } = useMutation(ISSUE_INVOICE);
  const { mutate: sendDocumentMutation } = useMutation(SEND_DOCUMENT);

  const submit = async () => {
    const issueResponse = await issueInvoiceMutation({
      input: {
        orderId: invoiceData.orderId,
        customerId: invoiceData.customer?.id,
        dueAt: dayjs().add(invoiceData.dueInDays, 'days').toISOString(),
      },
    });

    const issueSaleInvoice = issueResponse?.data?.issueSaleInvoice;
    if (issueSaleInvoice?.document?.id) {
      if (sendInvoice.value) {
        const sendResponse = await sendDocumentMutation({
          input: {
            documentId: issueSaleInvoice.document.id,
            email: emailInvoiceData.email,
            customSubject: emailInvoiceData.subject,
            customMessage: emailInvoiceData.content,
          },
        });
        if (sendResponse?.data?.sendSaleDocument.errors) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    } else {
      return false;
    }
  };

  return {
    sendInvoice,
    invoiceData,
    emailInvoiceData,
    submit,
  };
}
